import React, {memo, useEffect} from 'react';
import {PasswordContainer} from '../../components/PasswordContainer';
import {fetchAndInitialize} from '../../utils/initialize';
import {useDispatch} from 'react-redux';
import {useRPC} from '../../hooks/rpc';
import {useHistory} from 'react-router-dom';

export const LoginContent = memo(function LoginContent() {
    const dispatch = useDispatch();
    const [rpc] = useRPC();
    const history = useHistory();

    useEffect(() => {
        fetchAndInitialize(rpc, dispatch);
    }, [rpc, dispatch]);

    useEffect(() => {
        history.push('/');
    });

    return <></>;
});

export const LoginScreen = memo(function LoginScreen() {
    return (
        <PasswordContainer
            requiredRole={'default'}>
            <LoginContent/>
        </PasswordContainer>
    );
});
